<template>
  <div class="footer-info">
    <p>
      UniHomes is a trading name of UniHomes and Bills Limited, a company
      registered in England and Wales with company number 09618272 registered at
      6th Floor, 1 New Era Square, Sheffield S2 4RB. VAT Number: 218500925.
    </p>
  </div>
</template>

<script>
export default {
  name: "FooterInfo",
};
</script>

<style scoped lang="scss">
.footer-info {
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    font-size: 13px;
    font-weight: $font-regular;
    color: $grey-darkish;
  }

  @media (max-width: 768px) {
    padding-left: 30px;
    padding-right: 30px;
  }
}
</style>
